import React from "react";

class AddressCard extends React.Component {
  render() {
    const { address, isSelected, onSelect, onEdit } = this.props;

    return (
      <div
        style={{
          ...styles.card,
          ...(isSelected ? styles.selectedCard : {}),
        }}
        onClick={() => onSelect && onSelect(address)}
      >
        {/* Selection Radio */}
        <div style={styles.radioWrapper}>
          <input
            type="radio"
            checked={isSelected}
            onChange={() => onSelect && onSelect(address)}
            style={styles.radio}
          />
        </div>

        {/* Address Content */}
        <div style={styles.content}>
          <div style={styles.header}>
            <h6 style={styles.addressName}>
              {address.address_name || "Adres"}
            </h6>
            {onEdit && (
              <button
                type="button"
                onClick={function (e) {
                  e.stopPropagation();
                  onEdit(address);
                }}
                style={styles.editButton}
              >
                Düzenle
              </button>
            )}
          </div>

          <div style={styles.details}>
            <p style={styles.name}>
              {address.first_name} {address.last_name}
            </p>
            <p style={styles.text}>
              {address.address}, {address.town}, {address.city}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  card: {
    border: "1px solid #e5e4e9",
    borderRadius: "8px",
    padding: "18px 20px",
    marginBottom: "16px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    position: "relative",
    display: "flex",
    backgroundColor: "#fff",
    borderColor: "#e5e4e9",
    ":hover": {
      borderColor: "#84b817",
    },
  },
  selectedCard: {
    borderColor: "#84b817",
    backgroundColor: "#f7f7f9",
    boxShadow: "0 0 0 1px #84b817",
  },
  radioWrapper: {
    marginRight: "12px",
    display: "flex",
    alignItems: "flex-start",
    paddingTop: "4px",
  },
  radio: {
    width: "20px",
    height: "20px",
    cursor: "pointer",
    accentColor: "rgb(95, 141, 0)",
  },
  content: {
    flex: 1,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  addressName: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#212529",
    margin: 0,
  },
  editButton: {
    backgroundColor: "transparent",
    border: "none",
    color: "#84b817",
    padding: "0",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
    letterSpacing: "normal",
    lineHeight: "unset",
  },
  details: {
    margin: 0,
  },
  name: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#272727",
    marginBottom: "8px",
    margin: 0,
  },
  text: {
    fontSize: "14px",
    color: "#6c757d",
    marginBottom: "0",
    lineHeight: "1.5",
    margin: 0,
    // marginTop: "6px",
  },
  selectedBadge: {
    position: "absolute",
    top: "12px",
    right: "12px",
    fontSize: "24px",
    color: "#28a745",
  },
};

export default AddressCard;



// WEBPACK FOOTER //
// ./src/components/AddressStep/AddressCard.js